export default __webpack_public_path__ + "static/media/always_allow_on_every_site.000b7ea4.png";